<template>
  <div
    class="skeleton__filter"
    :class="{'skeleton__filter--no-padding': noPadding}"
  >
    <Skeleton class="skeleton__filter__header" />
    <Skeleton
      class="skeleton__filter__content"
      :shape="'rectangle'"
    />
    <div
      class="skeleton__filter__buttons"
    >
      <Skeleton
        class="skeleton__filter__buttons__reset"
        :shape="'rectangle'"
      />
      <Skeleton
        class="skeleton__filter__buttons__apply"
        :shape="'rectangle'"
      />
    </div>
  </div>
</template>
<script>
import {Skeleton} from '@progress/kendo-vue-indicators'

export default {
  components: {
    Skeleton
  },
  props: {
    noPadding: {
      type: Boolean,
      default() {
        return false
      }
    }
  }
}
</script>
